module.exports = __webpack_public_path__ + "img/Financiallocalization.5c50a5e6.svg";